<template lang="pug">
section.cadastro-territorio
    BaseHeader(
        :titulo='$t("mensagens.territorio.titulo")',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container-base-header
        .row.m-0
            el-form.formContainer.w-100.mb-3
                h2.titulo {{ $t('mensagens.territorio.informacoesCadastrais') }}
                .cadastro-territorio-campos
                    el-form-item.el-form-item-campos(
                        :label='$t("mensagens.territorio.labels.nomeFazenda")',
                        :rules='[{ required: true, trigger: "blur" }]'
                    )
                        el-input(
                            v-model='territorio.nome',
                            @blur='$v.territorio.nome.$touch()',
                            :placeholder='$t("mensagens.territorio.labels.nomeFazenda")',
                            :class='{ "error-border": $v.territorio.nome.$error }'
                        )
                        .error(
                            v-if='$v.territorio.nome.$error && !$v.territorio.nome.required'
                        ) {{ $t('mensagens.territorio.nomeNecessario') }}
                    el-form-item.el-form-item-campos(
                        v-if='!permissaoAmbiente(ambientes.PARAGUAY)',
                        :label='$t("mensagens.territorio.labels.certificacoes")'
                    )
                        el-select.w-100(
                            v-model='territorio.certificacoes',
                            multiple,
                            :placeholder='$t("mensagens.comuns.selecione")',
                            value-key='id'
                        )
                            el-option(
                                v-for='tipo in tipoCertificacao',
                                :key='tipo.id',
                                :value='tipo',
                                :label='tipo.nome'
                            ) {{ tipo.nome }}
                    el-form-item.el-form-item-campos(
                        :label='$t("mensagens.territorio.labels.pessoaVinculada")'
                    )
                        el-select.w-100(
                            v-model='territorio.representantes',
                            multiple,
                            :placeholder='$t("mensagens.comuns.selecione")',
                            filterable,
                            remote,
                            reserve-keyword,
                            :remote-method='remoteMethod',
                            :loading='loading',
                            @change='handleChangeSelectInput($event)',
                            value-key='id',
                            ref='elselectinput'
                        )
                            el-option(
                                v-for='representante in options',
                                :key='"representante" + representante.id',
                                :value='representante',
                                :label='representante.nomeRazaoSocial'
                            ) {{ representante.nomeRazaoSocial }}
                    el-form-item.el-form-item-campos(
                        :label='$t("mensagens.territorio.labels.padron")',
                        v-if='permissaoAmbiente(ambientes.PARAGUAY)'
                    )
                        el-input(
                            v-model='camposParaguay.padron',
                            @blur='$v.camposParaguay.padron.$touch()',
                            :placeholder='$t("mensagens.territorio.labels.padron")',
                            :class='{ "error-border": $v.camposParaguay.padron.$error }'
                        )
                .cadastro-territorio-campos
                    el-form-item.form-size.my-3(
                        :label='isAlvorada ? "BP Cliente" : this.$t("mensagens.territorio.labels.idCliente")'
                    )
                        el-input(
                            v-model='territorio.idCliente',
                            @blur='$v.territorio.idCliente.$touch()',
                            :placeholder='isAlvorada ? "BP Cliente" : this.$t("mensagens.territorio.labels.idCliente")'
                        )
                    el-form-item.form-size.my-3(
                        :label='$t("mensagens.territorio.labels.finca")',
                        v-if='permissaoAmbiente(ambientes.PARAGUAY)'
                    )
                        el-input(
                            v-model='camposParaguay.finca',
                            :placeholder='$t("mensagens.territorio.labels.finca")'
                        )
                ComercializacaoTerritorio(
                    v-if='dataLoaded && !permissaoAmbiente(ambientes.PARAGUAY)',
                    :comercializacaoSelected='territorio.comercializacoes'
                )

                InformacaoAgricula(
                    v-if='permissaoAmbiente(ambientes.PARAGUAY)',
                    :options='territorio.informacoesAgricolas',
                    :cultivos='cultura',
                    @update='updateArea',
                    @delete='deleteArea'
                )

        .row.m-0.mb-3
            .col-4.formContainer
                h2.text-left.py-4 {{ $t('mensagens.territorio.informacoesEspaciais') }}

                el-collapse(accordion, v-model='activeForms')
                    el-collapse-item(
                        v-if='!permissaoAmbiente(ambientes.PARAGUAY)',
                        :title='$t("mensagens.territorio.inserirAreasPorCodigoCarCpfCnpjNumeroParcelaIncra")',
                        name='CASE1',
                        style='border-bottom: 1px solid #ebeef5'
                    )
                        .row.m-0.d-flex.flex-row
                            el-input#carCodigo.mr-2(
                                type='text',
                                v-model='carCodigo',
                                :placeholder='$t("mensagens.territorio.numeroCarCpfCnpjParcelaIncra")',
                                style='width: 100%'
                            )
                                i.el-input__icon.el-icon-info(
                                    slot='suffix',
                                    :title='$t("mensagens.blocoFiltros.infos.pesquisarCarDocumento")'
                                )
                        .row.m-0.d-flex.flex-row-reverse
                            el-button.btn.btn-primary.row.my-2.mx-2(
                                style='width: auto',
                                type='primary',
                                @click='findCar'
                            )
                                | {{ $t('mensagens.comuns.adicionar') }}

                    el-collapse-item(
                        :title='$t("mensagens.territorio.uploadArquivosVetoriais")',
                        name='CASE2'
                    )
                        .row.m-0.d-flex.flex-row
                        el-upload.upload-demo(
                            drag,
                            :file-list='fileList',
                            action='alert',
                            :auto-upload='false',
                            :on-change='onLoadFile',
                            :on-remove='onRemoveFile',
                            ref='upload'
                        )
                            i.el-icon-upload(style='margin-top: 40px')
                            .el-upload__text {{ $t('mensagens.territorio.dragAndDrop.1') }}<em>{{ $t('mensagens.territorio.dragAndDrop.2') }}</em>

                    el-collapse-item(
                        v-if='!permissaoAmbiente(ambientes.PARAGUAY)',
                        :title='$t("mensagens.territorio.selecionarImovelCarMapa")',
                        name='CASE3'
                    )
                        .row.my-2.mx-0
                            el-row.pt-3
                                p {{ $t('mensagens.territorio.aposAtivarCamadaCliqueSobreLocalizacaoRural') }}
                                el-col
                                    el-button.large.w-100(
                                        :type='tipoBotao',
                                        @click='toggleSelecao'
                                    )
                                        .btn-selecao-mapa-body
                                            i.mdi.mdi-layers
                                            span {{ textoBotao }}

            .col-8.pr-0
                .mapa
                    mapa.map-content(
                        :mapLayersConfigs='layersMaps',
                        :mapConfig='mapConfig',
                        :idMapa='"mapaAddTerritorio"',
                        :height='"625px"',
                        @draw-created='adicionarDesenho',
                        @draw-edited='desenhosAlterados',
                        @removerTerritorio='removerTerritorio',
                        :deslocarPopup='true',
                        :menuMaior='true',
                        :cadastroTerritorio='true',
                        ref='mapa'
                    )

        .row
            listAreasTable(
                country='BR',
                @delete-upload-file='deleteUploadFile',
                @click-delete-area='clearSobreposicaoTerritorio',
                @set-localidades='setLocalidades',
                ref='table'
            )
        UploadArquivos(
            @add='addFile',
            @delete='deleteFile',
            :items='territorio.arquivosTerritorio',
            v-if='permissaoAmbiente(ambientes.PARAGUAY)'
        )

        .row.justify-content-end.py-3.m-0
            el-tooltip(
                effect='dark',
                :content='$t("mensagens.territorio.preencherCamposObrigatorios")',
                placement='top-start',
                :class='{ "item btn-disabled": this.$v.territorio.$invalid || this.territoryTableData.length !== 1 || this.territorioSobrePostoMessage }',
                :disabled='!(this.$v.territorio.$invalid || this.territoryTableData.length !== 1)'
            )
                el-button(
                    v-if='this.isAdding',
                    type='primary',
                    @click='addTerritorio',
                    style='width: 104px'
                )
                    | {{ $t('mensagens.comuns.cadastrar') }}
                el-button(
                    v-else,
                    type='primary',
                    @click='updateTerritorio',
                    style='width: 104px'
                )
                    | {{ $t('mensagens.comuns.salvar') }}

    el-dialog.dialog(
        width='600px',
        :title='$t("mensagens.territorio.poligonoSobreposto.titulo")',
        :visible.sync='mostrarModalSobreposicaoKMZ',
        :close-on-click-modal='false',
        :before-close='fecharModalSobreposicaoKMZ'
    )
        span {{ $t('mensagens.territorio.poligonoSobreposto.mensagem') }} <br> {{ $t('mensagens.territorio.poligonoSobreposto.pergunta') }}

        footer.espaco(slot='footer')
            el-button(
                type='default',
                @click='confirmarValidacaoSobreposicaoCatastroPY("geomBaseCatrastro")'
            ) {{ $t('mensagens.territorio.poligonoSobreposto.cancelar') }}
            el-button(
                type='primary',
                @click='confirmarValidacaoSobreposicaoCatastroPY("geomInserido")'
            ) {{ $t('mensagens.territorio.poligonoSobreposto.continuar') }}

    el-dialog.dialog(
        width='600px',
        :title='$t("mensagens.territorio.territorioSobrepostoModal.titulo")',
        :visible.sync='mostrarModalSobreposicaoPoligono',
        :close-on-click-modal='false',
        :before-close='fecharModalSobreposicaoPoligono'
    )
        span {{ $t('mensagens.territorio.territorioSobrepostoModal.mensagem') }}
        <div class="territorio">
            span(
                v-for='territorio in listaTerritoriosComIntersecaoPY',
                :key='territorio.id'
            ) - {{ territorio.nome }}
        </div>
        span {{ $t('mensagens.territorio.territorioSobrepostoModal.pergunta') }}

        footer.espaco(slot='footer')
            el-button(
                type='default',
                @click='confirmarValidaIntersecoesTerritoriosParaguay("")'
            ) {{ $t('mensagens.territorio.territorioSobrepostoModal.cancelar') }}
            el-button(
                type='primary',
                @click='confirmarValidaIntersecoesTerritoriosParaguay("confirmar")'
            ) {{ $t('mensagens.territorio.territorioSobrepostoModal.continuar') }}

    div(v-if='dialogListaCarSelect')
        ModalSelecionarCarsSobrepostos(
            :show='dialogListaCarSelect',
            :cars='Array.from(carsSet)',
            :geometriaTerritorio='territorio.geoJson',
            @voltar='dialogListaCarSelect = false',
            @salvar='savarCarsVinculados'
        )

    div(v-if='mostrarModalDadosCpfCnpj')
        ModalSelecionarDadosCpfCnpj(
            :show='mostrarModalDadosCpfCnpj',
            :cpfCnpj='carVinculadoCpfCnpj',
            tipo='TERRITORIO',
            :dados='dados',
            @voltar='mostrarModalDadosCpfCnpj = false',
            @retornarDadosSelecionados='adicionarDadosSelecionadosNaModalNoMapa'
        )

    el-dialog.dialog-lista-select(
        :visible.sync='territorioSobrePosto',
        :title='$t("mensagens.territorio.territorioSobreposto")',
        :close-on-click-modal='false',
        :close-on-press-escape='true',
        :destroy-on-close='true',
        :show-close='true',
        width='565.8px'
    )
        p.pre-formatted {{ this.territorioSobrePostoMessage }}
        .d-flex.flex-direction.justify-content-between.posicao-botao
            el-button(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
            el-button(
                slot='footer',
                size='mini',
                type='primary',
                @click='continuarTerritorioSobreposto'
            ) {{ $t('mensagens.comuns.continuar') }}
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { get } from 'lodash';
import L from 'leaflet';
import { mapActions, mapGetters, mapState } from 'vuex';

import territorioService from '@/services/TerritorioService';
import LocalidadeService from '@/services/LocalidadeService';
import representanteService from '@/services/RepresentanteService';
import MunicipioService from '@/services/MunicipioService';
import CarService from '@/services/car/CarService';
import SigefService from '@/services/SigefService';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import CulturaService from '@/services/CulturaService.js';

import geometryConverter from '@/utils/conversorGeometrias';
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import geometryUtils from '@/utils/mapa/geometry.js';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import EventBus from '@/utils/eventBus';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

import Mapa from '@/components/MapaLeaflet';
import ModalSelecionarCarsSobrepostos from '@/components/territorio/ModalSelecionarCarsSobrepostos';
import listAreasTable from '@/components/listAreasTable/ListAreasTable';
import InformacaoAgricula from '@/components/territorio/InformacaoAgricula.vue';
import BaseHeader from '@/components/BaseHeader';
import EmptyResult from '@/components/EmptyResult';
import ComercializacaoTerritorio from '@/components/territorio/Comercializacao';
import ModalSelecionarDadosCpfCnpj from '@/components/ModalSelecionarDadosCpfCnpj';
import UploadArquivos from '@/components/territorio/UploadArquivos.vue';

export default {
    name: 'CadastrarEditarTerritorio',
    components: {
        BaseHeader,
        EmptyResult,
        Mapa,
        listAreasTable,
        ModalSelecionarCarsSobrepostos,
        ComercializacaoTerritorio,
        ModalSelecionarDadosCpfCnpj,
        UploadArquivos,
        InformacaoAgricula
    },
    data() {
        return {
            dataLoaded: false,
            isAdding: null,
            isAddingOrEditingTerritorio: true,
            isIgnoreSobreposition: false,
            mostrarModalSobreposicaoKMZ: false,
            mostrarModalSobreposicaoPoligono: false,
            territorio: {
                nome: null,
                representantes: [],
                city: null,
                state: null,
                area: null,
                comercializacoes: null,
                certificacoes: null,
                idCliente: null,
                informacoesAgricolas: [],
                arquivosTerritorio: []
            },
            carregandoDadosDistritoParaguay: false,
            camposParaguay: {
                departamento: null,
                distrito: null,
                padron: null,
                finca: null
            },
            addTerritorioSuccess: false,
            selectedTerritorio: {},
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    popupControl: true,
                    drawControl: true
                },
                dontZoomIn: true,
                fitBounds: true,
                addLimitesEstado: false,
                inspecionar: true
            },
            actionType: 'Cadastrar',
            activeForms: [],
            estados: [],
            estadoSelecionado: null,
            municipios: [],
            municipioSelecionado: null,
            fileList: [],
            representanteData: [],
            representanteSelecionado: null,
            pageToFetch: 0,
            ativo: false,
            resultados: [],
            geometria: null,
            loading: false,
            options: [],
            sendToMonitormanetoModal: false,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 5
            },
            arquivosUploads: [],
            carsSet: [],
            carsCondicao: {},
            carByCode: '',
            gemotryByCarCode: '',
            geometryDesenho: '',
            carByGeometry: '',
            carSelected: '',
            dialogListaCarSelect: false,
            territorioSobrePosto: false,
            territorioSobrePostoMessage: null,
            territorioInicial: {},
            layersMaps: [],
            carCodigo: null,
            carsCpfCnpj: [],
            carVinculadoCpfCnpj: null,
            mostrarModalDadosCpfCnpj: false,
            municipioBuffer: {},
            dados: {
                carEstadoPaginado: [],
                existemDados: false
            },
            tipoCertificacao: [],
            listaTerritoriosComIntersecaoPY: [],
            retornoValidacaoSobreposicaoCatastro: {},
            validacaoBaseCatastroRealizadaPY: false,
            ambientes: AmbientesEmpresas,
            cultura: [],
            informacoesAgricolas: []
        };
    },
    validations: {
        territorio: {
            nome: {
                required
            },
            idCliente: {}
        },
        camposParaguay: {
            departamento: {
                required: false
            },
            distrito: {
                required: false
            },
            padron: {
                required: false
            }
        }
    },
    mounted() {
        const { getters } = this.$store;
        const representante = getters.representante;

        this.fetchTerritorios();
        this.fetchRepresentantes();
        this.fetchTipoCertificacao();
        this.getCultura();

        if (!this.territorio.informacoesAgricolas) {
            this.territorio.informacoesAgricolas = [];
        }

        if (this.territorioData.value === 'edit') {
            this.territorioInicial = this.territorioData.geometria;

            const sanitizeValue = value =>
                value !== 'null' && value !== null && value !== undefined
                    ? value
                    : '';

            this.camposParaguay.padron = sanitizeValue(
                this.territorioData.padron
            );
            this.camposParaguay.finca = sanitizeValue(
                this.territorioData.finca
            );
        }

        this.$bus.$on('comercializacao', data => {
            this.territorio.comercializacoes = data;
        });

        if (this.$route.params.cadastrar) {
            this.mostrarModalEditarCadastrarRepresentante = true;
            this.editar = false;
            this.territorio.nome = this.$route.params.cadastrar;
        }

        if (representante.id) {
            const repr = this.options.findIndex(
                item => item.id === representante.id
            );
            if (repr) {
                this.options.push({ ...representante });
            }

            if (typeof representante.tipoDocumento === 'object') {
                representante.idTipoDocumento = representante.tipoDocumento.id;
            }
            this.territorio.representantes.push({ ...representante });
            this.removeRepresentante();
        }
    },

    beforeDestroy() {
        this.setRepresentante({
            id: null,
            usuario: null,
            idUsuario: null,
            nomeRazaoSocial: null,
            cpfCnpj: null,
            idCliente: null,
            email: null,
            ativo: null,
            dataCadastro: null,
            dataAtualizacao: null,
            empresas: null,
            cpfCnpjCrypt: null
        });
        this.territorio = null;
        this.limparTerritorioData();
    },

    beforeUnmount() {
        this.territorio = null;
    },

    created() {
        EventBus.$on(
            'mapa:desativar-se-ativo-selecao',
            this.desativarSelecaoSeAtivo
        );
    },
    computed: {
        ...mapGetters([
            'territorioData',
            'territoryTableData',
            'representante',
            'usuarioLogado',
            'isAlvorada'
        ]),
        ...mapState(['usuarioLogado']),
        pagedTableData() {
            return this.tableData.slice(
                this.pageSize * this.page - this.pageSize,
                this.pageSize * this.page
            );
        },
        tipoBotao() {
            return this.ativo ? 'default' : 'primary';
        },
        textoBotao() {
            return this.ativo
                ? this.$t('mensagens.territorio.desativarSelecaoMapa')
                : this.$t('mensagens.territorio.ativarSelecaoMapa');
        }
    },
    watch: {
        search() {
            if (!this.search) {
                this.total = this.tableData.length;
                return this.tableData;
            }
            this.page = 1;
            this.total = this.pagedTableData.length;
            return this.tableData.filter(
                data =>
                    !this.search ||
                    data.nomeRazaoSocial
                        .toLowerCase()
                        .includes(this.search.toLowerCase())
            );
        },
        territoryTableData() {
            this.fitBoundsGeometriasTabela();
        },
        carCodigo: function (value) {
            if (value?.length > 0) {
                let mascara = '';
                value = value.replace(/[^\w\s]/gi, '');

                if (value.length === 13) {
                    mascara = value;
                } else if (value.length <= 14 && /[A-Z0-9]{12}[0-9]{2}/.test(value)) {
                    mascara = formatters.numeralStringFormatTocpfCnpj(value);
                } else if (value.length > 14 && value.length <= 32) {
                    mascara = formatters.formatCodigoParcela(value);
                } else {
                    mascara = formatters.formatCar(value);
                }
                this.carCodigo = mascara;
            }
        }
    },
    methods: {
        closeDialog() {
            this.territorioSobrePosto = false;
        },

        ...mapActions([
            'setRepresentante',
            'setTerritoryTableData',
            'clearTerritoryTableData',
            'clearTerritorio',
            'replaceTerritoryTableData',
            'removeTerritoryTableData',
            'removeRepresentante',
            'limparTerritorioData'
        ]),

        async getCultura() {
            try {
                const { data } = await CulturaService.buscarCultura();
                this.cultura = data;
            } catch (error) {}
        },

        addFile(file) {
            const { arquivosTerritorio } = this.territorio;

            const countFilesByType = isProdutor =>
                arquivosTerritorio.filter(
                    arquivo => arquivo.arquivoProdutor === isProdutor
                ).length;

            const isBelowLimit = isProdutor => countFilesByType(isProdutor) < 3;

            if (isBelowLimit(file.arquivoProdutor)) {
                arquivosTerritorio.push(file);
            }
        },

        deleteFile(fileId) {
            const index = this.territorio.arquivosTerritorio.findIndex(item => {
                if (item?.arquivo) {
                    return item.arquivo.id === fileId;
                }

                return item.id === fileId;
            });

            if (index !== -1) {
                this.territorio.arquivosTerritorio.splice(index, 1);
            }
        },

        updateArea(params) {
            this.territorio.informacoesAgricolas.push(params);
        },

        deleteArea(index) {
            this.territorio.informacoesAgricolas.splice(index, 1);
        },
        removerTerritorio(identificadorGeometria) {
            this.territoryTableData.forEach((item, index) => {
                if (identificadorGeometria === item.identificadorGeometria) {
                    this.removeTerritoryTableData(index);
                }
            });
        },

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        fetchStates() {
            LocalidadeService.findEstados().then(({ data }) => {
                this.estados = data;
            });
        },

        fecharModalSobreposicaoKMZ() {
            this.mostrarModalSobreposicaoKMZ = false;
        },

        fecharModalSobreposicaoPoligono() {
            this.mostrarModalSobreposicaoPoligono = false;
        },

        deleteUploadFile(name) {
            const removeFile = this.$refs.upload.uploadFiles.filter(
                f => f.name === name
            )[0];
            this.$refs.upload.uploadFiles =
                this.$refs.upload.uploadFiles.filter(f => f.name !== name);
            this.onRemoveFile(removeFile, null);
        },

        fetchTerritorios() {
            if (this.territorioData.value === 'edit') {
                this.territorio = this.territorioData;
                this.territorio.informacoesAgricolas =
                    this.territorioData.informacaoAgricolaPY;
                this.addPropSafraComercializacoes();
                this.isAdding = false;
                this.setMapGeometry();
            } else {
                this.clearAll();
                this.isAdding = true;
            }
            this.dataLoaded = true;
        },

        async buscarCarsSobrepostoTerritorio() {
            try {
                const { data } = await territorioService.findCarsByTerritorio(
                    this.territorio.geoJson
                );
                this.carsSet = [];
                data.forEach(({ codigo, condicao }) => {
                    this.carsSet.push(codigo);
                    this.carsCondicao[codigo] = condicao;
                });

                if (this.carsSet.length > 0) {
                    this.dialogListaCarSelect = true;
                } else {
                    this.territorio.carsVinculados = [];
                    this.salvarTerritorio();
                }
            } catch (error) {
                this.$notify.error({
                    message: get(error, 'response.data.message', error.message)
                });
            }
        },

        clearSobreposicaoTerritorio() {
            this.territorioSobrePostoMessage = null;
            this.territorioSobrePosto = false;
        },

        setLocalidades(localidades) {
            this.camposParaguay.departamento = localidades.codigoDepartamento;
            this.camposParaguay.distrito = localidades.codigoDistrito;
        },

        async addTerritorio() {
            this.$v.territorio.$touch();

            if (this.permissaoAmbiente(this.ambientes.PARAGUAY)) {
                this.validacaoTerritorioParaguay();
            } else {
                this.validacaoTerritorioDefault();
            }
        },

        async validacaoTerritorioDefault() {
            if (this.checkIfIsValid()) {
                this.territorio.geoJson = this.territoryTableData[0].geometry;
                this.clearSobreposicaoTerritorio();
                if (this.isIgnoreSobreposition) {
                    if (this.territoryTableData[0].type === 'CAR') {
                        this.territorio.carsVinculados = [];
                        this.territorio.carsVinculados.push(
                            this.territoryTableData[0].codigo
                        );
                        this.carsCondicao[this.territoryTableData[0].codigo] =
                            this.territoryTableData[0].situacao;

                        this.salvarTerritorio();
                    } else {
                        await this.buscarCarsSobrepostoTerritorio();
                    }
                } else {
                    territorioService
                        .validarSobreposicaoTerritorio(this.territorio.geoJson)
                        .then(async () => {
                            if (this.territoryTableData[0].type === 'CAR') {
                                this.territorio.carsVinculados = [];
                                this.territorio.carsVinculados.push(
                                    this.territoryTableData[0].codigo
                                );
                                this.carsCondicao[
                                    this.territoryTableData[0].codigo
                                ] = this.territoryTableData[0].situacao;

                                this.salvarTerritorio();
                            } else {
                                await this.buscarCarsSobrepostoTerritorio();
                            }
                        })
                        .catch(error => {
                            const message = get(
                                error,
                                'response.data.message',
                                error.message
                            );
                            this.territorioSobrePostoMessage = message;
                            this.territorioSobrePosto = true;
                        });
                }
            }
        },

        /**
         * Valida e processa um território no Paraguai, verificando sobreposições
         * e salvando se válido.
         */
        async validacaoTerritorioParaguay() {
            try {
                this.$v.camposParaguay.$touch();
                if (!this.checkIfIsValid()) {
                    return;
                }

                this.territorio.geoJson = this.territoryTableData[0].geometry;
                const padronInformado = this.camposParaguay.padron;

                if (!padronInformado) {
                    await this.salvarTerritorioParaguay();
                    return;
                }

                const padronValidado = await this.validaPadronCatrastroPY();
                if (!padronValidado) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.territorioSobrepostoModal.dadosNaoEncontradosBaseCatastro'
                        )
                    });
                    return;
                }

                this.clearSobreposicaoTerritorio();
                const sobreposicaoValida =
                    await this.validaSobreposicaoCatastroPY();
                if (!sobreposicaoValida) {
                    return;
                }

                if (
                    this.retornoValidacaoSobreposicaoCatastro
                        .sobreposicaoBaseCatastro &&
                    !this.validacaoBaseCatastroRealizadaPY
                ) {
                    this.mostrarModalSobreposicaoKMZ = true;
                    return;
                }

                await this.validaIntersecoesTerritoriosParaguay();
                if (this.listaTerritoriosComIntersecaoPY.length !== 0) {
                    this.mostrarModalSobreposicaoPoligono = true;
                    return;
                }

                await this.salvarTerritorioParaguay();
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroAoSalvarTerritorio'
                    )
                });
            }
        },

        async validaPadronCatrastroPY() {
            const idDistrito = this.camposParaguay.distrito.replace(/\D/g, '');
            try {
                const response =
                    await territorioService.validacaoDadosCadastroParaguay(
                        this.camposParaguay.departamento,
                        idDistrito,
                        this.camposParaguay.padron
                    );

                const { data } = response;

                const padronInteiro = parseInt(this.camposParaguay.padron, 10);

                if (data.padron !== padronInteiro) {
                    return false;
                }

                return true;
            } catch (error) {
                return false;
            }
        },

        async validaSobreposicaoCatastroPY() {
            const idDistrito = this.camposParaguay.distrito.replace(/\D/g, '');

            const response =
                await territorioService.validaSobreposicaoCatastroParaguay(
                    this.territorio.geoJson,
                    this.camposParaguay.departamento,
                    idDistrito,
                    this.camposParaguay.padron
                );

            if (
                !response.data.features ||
                response.data.features.length === 0
            ) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.territorioSobrepostoModal.dadosNaoEncontradosBaseCatastro'
                    )
                });
                return false;
            }
            const { data } = response;

            this.retornoValidacaoSobreposicaoCatastro = data;
            return true;
        },

        async validaIntersecoesTerritoriosParaguay() {
            const idTerritorio =
                this.territorioData.value === 'edit' ? this.territorio.id : 0;

            const response =
                await territorioService.validaIntersecoesTerritoriosParaguay(
                    this.territorio.geoJson,
                    idTerritorio
                );
            this.listaTerritoriosComIntersecaoPY = response.data;
        },

        async salvarTerritorioParaguay() {
            if (!this.validarComercializacao()) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.territorio.itemComercializacaoCampoObrigatorio'
                    )
                });
                return;
            }

            this.removePropSafraComercializacoes();

            if (this.territorioData.value === 'edit') {
                territorioService
                    .updateParaguay(this.territorio, this.camposParaguay)
                    .then(response => {
                        this.updateTerritorioModal = false;
                        this.isAddingOrEditingTerritorio = false;
                        this.fetchTerritorios();
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.territorioEditadoSucesso'
                            )
                        });
                        this.$router.push({ name: 'Territorio' });
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: get(
                                error,
                                'response.data.message',
                                error.message
                            )
                        });
                    });
            } else {
                try {
                    await territorioService.addParaguay(
                        this.territorio,
                        this.camposParaguay
                    );

                    this.isAddingOrEditingTerritorio = false;
                    this.addTerritorioSuccess = true;
                    this.territorio.representantes = [];

                    this.$notify.success({
                        message: this.$t(
                            'mensagens.territorio.territorioAdicionadoSucesso'
                        )
                    });

                    this.$router.push({ name: 'Territorio' });
                } catch (erro) {
                    this.$notify.error({
                        message: erro.response.data?.message.includes(
                            this.$t('mensagens.territorio.geometriaNaoValida')
                        )
                            ? this.$t(
                                  'mensagens.territorio.erroCadastroTerritorioGeometriaInvalida'
                              )
                            : this.$t(
                                  'mensagens.territorio.erroAoSalvarTerritorio'
                              )
                    });
                }
            }
        },

        async confirmarValidacaoSobreposicaoCatastroPY(tipoEscolhido) {
            this.validacaoBaseCatastroRealizadaPY = true;
            if (tipoEscolhido === 'geomBaseCatrastro') {
                this.territorio.geoJson =
                    this.retornoValidacaoSobreposicaoCatastro.features[0].geometry;
            } else {
                this.territorio.geoJson = this.territoryTableData[0].geometry;
            }

            this.fecharModalSobreposicaoKMZ();

            await this.validaIntersecoesTerritoriosParaguay();

            if (this.listaTerritoriosComIntersecaoPY.length !== 0) {
                this.mostrarModalSobreposicaoPoligono = true;
            } else {
                this.salvarTerritorioParaguay();
            }
        },

        confirmarValidaIntersecoesTerritoriosParaguay(tipoEscolhido) {
            if (tipoEscolhido === 'confirmar') {
                this.salvarTerritorioParaguay();
                this.fecharModalSobreposicaoPoligono();
            } else if (
                this.retornoValidacaoSobreposicaoCatastro
                    .sobreposicaoBaseCatastro &&
                this.validacaoBaseCatastroRealizadaPY
            ) {
                this.fecharModalSobreposicaoPoligono();
                this.mostrarModalSobreposicaoKMZ = true;
            } else {
                this.fecharModalSobreposicaoPoligono();
            }
        },

        async salvarTerritorio() {
            if (!this.validarComercializacao()) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.territorio.itemComercializacaoCampoObrigatorio'
                    )
                });
                return;
            }
            const carsVinculados = [...this.territorio.carsVinculados];
            this.territorio.carsVinculados = [];

            this.territorio.representantes.forEach(representante => {
                if (isNaN(new Date(representante.dataAtualizacao).getTime())) {
                    representante.dataAtualizacao = null;
                }
            });

            carsVinculados.forEach(car => {
                this.territorio.carsVinculados.push({
                    codigo: car,
                    condicao: this.carsCondicao[car]
                });
            });

            this.territorio.validarSobreposicao = !this.isIgnoreSobreposition;
            this.removePropSafraComercializacoes();

            if (this.territorioData.value === 'edit') {
                territorioService
                    .update(this.territorio)
                    .then(response => {
                        this.updateTerritorioModal = false;
                        this.isAddingOrEditingTerritorio = false;
                        this.fetchTerritorios();
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.territorioEditadoSucesso'
                            )
                        });
                        this.$router.push({ name: 'Territorio' });
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: get(
                                error,
                                'response.data.message',
                                error.message
                            )
                        });
                    });
            } else {
                try {
                    const { data } = await territorioService.add(
                        this.territorio
                    );
                    this.isAddingOrEditingTerritorio = false;
                    this.addTerritorioSuccess = true;
                    this.territorio.representantes = [];

                    this.$notify.success({
                        message: this.$t(
                            'mensagens.territorio.territorioAdicionadoSucesso'
                        )
                    });

                    this.realizarDiagnostico(data);
                    this.$router.push({ name: 'Territorio' });
                } catch (erro) {
                    this.$notify.error({
                        message: erro.response.data.message.includes(
                            this.$t('mensagens.territorio.geometriaNaoValida')
                        )
                            ? this.$t(
                                  'mensagens.territorio.erroCadastroTerritorioGeometriaInvalida'
                              )
                            : this.$t(
                                  'mensagens.territorio.erroAoSalvarTerritorio'
                              )
                    });
                }
            }
        },

        async realizarDiagnostico(territorio) {
            await DiagnosticoSocioambientalService.realizarDiagnosticoCadastroTerritorio(
                territorio.id
            );
        },

        async continuarTerritorioSobreposto() {
            this.isIgnoreSobreposition = true;
            this.clearSobreposicaoTerritorio();
            this.addTerritorio();
            this.closeDialog();
        },

        async updateTerritorio() {
            this.$v.territorio.$touch();

            if (this.permissaoAmbiente(this.ambientes.PARAGUAY)) {
                this.validacaoTerritorioParaguay();
            } else {
                this.validacaoUpdateDefault();
            }
        },

        validacaoUpdateDefault() {
            if (this.checkIfIsValid()) {
                this.territorio.geoJson = this.territoryTableData[0].geometry;

                territorioService
                    .validarSobreposicaoTerritorio(
                        this.territorio.geoJson,
                        this.territorio.id
                    )
                    .then(async () => {
                        await this.buscarCarsSobrepostoTerritorio();

                        if (
                            this.territorioInicial === this.territorio.geoJson
                        ) {
                            this.territorio.carsVinculados = [];

                            this.territorioData.cars.forEach(
                                ({ codigo, condicao }) => {
                                    this.territorio.carsVinculados.push(codigo);
                                    this.carsCondicao[codigo] = condicao;
                                }
                            );
                        }
                    })
                    .catch(error => {
                        get(error, 'response.data.message', error.message);
                        this.territorioSobrePostoMessage =
                            this.$t(
                                'mensagens.territorio.territorioComSobreposicaoJaCadastrada1'
                            ) +
                            ': \n" + nomesTerritorios + "\n' +
                            this.$t(
                                'mensagens.territorio.territorioComSobreposicaoJaCadastrada3'
                            );
                        this.territorioSobrePosto = true;
                    });
            }
        },

        findMunicipios(idEstado) {
            this.municipioSelecionado = null;
            this.municipios = null;
            if (idEstado != null) {
                LocalidadeService.findMunicipios(idEstado).then(({ data }) => {
                    this.municipios = data;
                });
            }
        },

        onLoadFile(file) {
            let reader = new FileReader();
            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                await geometryConverter
                    .read(extension, e.target.result, file.raw)
                    .then(geometria => {
                        this.processarGeometria(geometria, file.name);

                        this.arquivosUploads.push({
                            id: file.uid,
                            layer: geometria,
                            name: file.name
                        });
                    })
                    .catch(rejectReason => {
                        this.$refs.upload.clearFiles();
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        processarGeometria(geometria, fileName) {
            this.filtrarGeometrias(geometria);
            if (geometria !== null && geometria.getLayers().length > 0) {
                if (
                    geometria.getLayers()[0].feature.geometry.type ===
                    'GeometryCollection'
                ) {
                    _.each(geometria.getLayers()[0].getLayers(), layer =>
                        this.processarLayer(geometria, layer, fileName)
                    );
                } else {
                    _.each(geometria.getLayers(), layer =>
                        this.processarLayer(geometria, layer, fileName)
                    );
                }
            } else {
                this.$refs.upload.clearFiles();

                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.arquivoNaoPossuiGeometriaValida'
                    )
                });
            }
        },

        processarLayer(geometria, layer, fileName) {
            let geometriaPolygon = this.verificaTipoCorretoGeometria(
                layer.feature.geometry
            );
            let territoryPropertyConverionToTableData = {};

            territoryPropertyConverionToTableData.identificadorGeometria =
                layer._leaflet_id;
            layer.identificadorGeometria = layer._leaflet_id;
            territoryPropertyConverionToTableData.type = 'UPLOAD';
            territoryPropertyConverionToTableData.codigo = 'UPLOAD';
            territoryPropertyConverionToTableData.area_ha =
                geometryUtils.calcularAreaHaFromLayer(layer);
            territoryPropertyConverionToTableData.geometry = geometriaPolygon;
            territoryPropertyConverionToTableData.fileName = fileName;

            this.setTerritoryTableData(territoryPropertyConverionToTableData);
            this.clearSobreposicaoTerritorio();

            const uploadStyle = {
                color: 'red'
            };

            geometria.setStyle(uploadStyle);

            this.$refs.mapa.mapa.addLayer(geometria);
            this.$refs.mapa.mapa.fitBounds(geometria.getBounds());
        },
        /* Permite apenas Features e Geometries do tipo '(Multi)Polygon' */
        filtrarGeometrias(layerGeometrias) {
            if (!layerGeometrias) return;

            if (layerGeometrias.getLayers) {
                layerGeometrias.getLayers().forEach(layer => {
                    if (!(layer instanceof L.Polygon)) {
                        if (layer instanceof L.LayerGroup) {
                            return this.filtrarGeometrias(layer);
                        }

                        if (layer instanceof L.Polyline) {
                            const coordinates = layer.getLatLngs();
                            if (!this.isValidLatLngArray(coordinates)) {
                                // eslint-disable-next-line no-console
                                console.warn(
                                    'Coordenadas inválidas para Polyline:',
                                    coordinates
                                );
                                return;
                            }

                            return this.filtrarGeometrias(layer);
                        }

                        layerGeometrias.removeLayer(layer);
                    }
                });
            } else {
                if (!(layerGeometrias instanceof L.Polygon)) {
                    return L.featureGroup();
                }
            }
        },
        isValidLatLngArray(latlngArray) {
            if (!Array.isArray(latlngArray) || latlngArray.length === 0) {
                return false;
            }
            return latlngArray.every(coord => {
                if (Array.isArray(coord)) {
                    return this.isValidLatLngArray(coord);
                }
                return (
                    coord &&
                    coord.lat !== undefined &&
                    coord.lng !== undefined &&
                    coord.lat >= -90 &&
                    coord.lat <= 90 &&
                    coord.lng >= -180 &&
                    coord.lng <= 180
                );
            });
        },

        verificaTipoCorretoGeometria(geometria) {
            if (geometria.type === 'LineString') {
                const coordinates = [...geometria.coordinates];
                if (coordinates.length === 0) return null;

                coordinates.push(coordinates[0]);

                return {
                    type: 'Polygon',
                    coordinates: [coordinates]
                };
            }

            return geometria;
        },

        onRemoveFile(file, fileList) {
            let itemToRemove = _.find(this.arquivosUploads, o => {
                return o.uid === file.id;
            });

            if (itemToRemove) {
                this.$refs.mapa.mapa.removeLayer(itemToRemove.layer);
            }

            _.remove(this.arquivosUploads, o => {
                return o.uid === file.id;
            });

            const index = this.$refs.table.territoryTableData.findIndex(
                d => d.fileName === file.name
            );
            this.$refs.table.removeTerritoryTableData(index);
        },

        getFiltros(query) {
            const filtro = {};
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.searchText = query || '';
            if (query && validators.validarCpf(query)) {
                filtro.searchText = formatters.cpfCnpjFormatToNumeral(query);
            }
            filtro.order = '&sort=nome_razao_social,asc';
            return filtro;
        },

        async fetchRepresentantes(query) {
            try {
                const { data } = await representanteService.findAllByFiltro(
                    this.getFiltros(query)
                );
                this.representanteData = this.representanteData.concat(
                    data.itens
                );
                this.representanteData = this.representanteData.filter(
                    (v, i, a) => a.findIndex(t => t.id === v.id) === i
                );
                this.options = data.itens.slice(0, 5);
                if (this.territorioData.value === 'edit') {
                    let intersection = [];
                    let difference = [];
                    this.options.forEach(value => {
                        this.territorio.representantes.forEach(item => {
                            if (item.id === value.id) {
                                intersection.push(item);
                            }
                        });
                    });
                    difference = this.territorio.representantes.filter(
                        value => !intersection.includes(value)
                    );
                    this.options.push(...difference);
                }

                if (this.representante.id) {
                    const repr = this.options.findIndex(
                        item => item.id === this.representante.id
                    );
                    if (repr) {
                        this.options.push({ ...this.representante });
                    }
                }
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.erroAoBuscarPessoas')
                });
            } finally {
                this.loading = false;
            }
        },

        async fetchTipoCertificacao() {
            try {
                const { data } =
                    await territorioService.buscarTipoCertificacao();
                this.tipoCertificacao = data;
            } catch (e) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroAoBuscarTiposCertificacao'
                    )
                });
            }
        },

        toggleSelecao() {
            this.ativo = !this.ativo;
            if (this.ativo) {
                this.ativarSelecao();
            } else {
                this.desativarSelecao();
            }
        },
        desativarSelecaoSeAtivo() {
            if (this.ativo) {
                this.desativarSelecao();
                this.ativo = false;
            }
        },
        ativarSelecao() {
            this.$bus.$emit('mapa:ativar-camada-onclick-car');
        },
        desativarSelecao() {
            EventBus.$emit('cadastro-territorio:fechar-modal-car-selecionado');
            this.$bus.$emit('mapa:desativar-camada-onclick-car');
            this.territorio.geoJson = null;
            this.fitBoundsGeometriasTabela();
        },
        fitBoundsGeometriasTabela() {
            if (
                this.territoryTableData.length &&
                this.$refs &&
                this.$refs.mapa &&
                this.$refs.mapa.mapa
            ) {
                const group = new L.FeatureGroup();
                this.territoryTableData.forEach(territorioTabela => {
                    group.addLayer(L.geoJSON(territorioTabela.geometry));
                });
                this.$refs.mapa.mapa.fitBounds(group.getBounds());
            }
        },
        setMapGeometry() {
            const identificadorGeometria = new Date().getTime();

            const territoryPropertyConverionToTableData = {};
            territoryPropertyConverionToTableData.type = 'AREA_CONSOLIDADA';
            territoryPropertyConverionToTableData.codigo = 'AREA_CONSOLIDADA';
            territoryPropertyConverionToTableData.area_ha =
                this.territorioData.areaHa;
            territoryPropertyConverionToTableData.geometry =
                this.territorioData.geometria;
            territoryPropertyConverionToTableData.identificadorGeometria =
                identificadorGeometria;

            this.clearTerritoryTableData();
            this.setTerritoryTableData(territoryPropertyConverionToTableData);
            this.clearSobreposicaoTerritorio();

            this.mostrarTerritorioNoMapa(
                this.territorioData.geometria,
                identificadorGeometria
            );
        },

        mostrarTerritorioNoMapa(geometria, identificadorGeometria) {
            this.layersMaps = [];

            geometria.identificadorGeometria = identificadorGeometria;

            const layerTerritorio = {
                style: mapaEstilos.Geometria.imovelRuralCandidato,
                name: identificadorGeometria,
                geoJson: geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        clearAll() {
            this.clearTerritoryTableData();
            this.territorio.nome = null;
            this.clearTerritorio();
        },
        remoteMethod(query) {
            this.loading = true;
            setTimeout(() => {
                this.fetchRepresentantes(query);
            }, 800);
        },
        dadoJaFoiAdicionado(dado) {
            let result = false;
            if (this.territoryTableData.length === 0) {
                result = false;
            } else {
                this.territoryTableData.forEach(item => {
                    if (item.codigo === dado) {
                        result = true;
                    }
                });
            }
            return result;
        },

        async getDadosMunicipio(item) {
            const idMunicipio = item.properties.id_municipio;

            if (this.municipioBuffer[idMunicipio]) {
                return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
            } else {
                try {
                    const { data } = await MunicipioService.getMunicipioById(
                        idMunicipio
                    );
                    this.municipioBuffer[idMunicipio] = data;
                    return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
                } catch (e) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.erroAoBuscarDadosMunicipio'
                        )
                    });
                    return '-';
                }
            }
        },

        async buscarCarPorCpfCnpjVinculado() {
            const codigo = this.carCodigo.replace(/[^\w\s]/gi, '');
            try {
                const { data: dataCar } =
                    await CarService.buscarCarPorCpfCnpjVinculado(codigo);
                const { data: listaSigef } =
                    await SigefService.consultarCpfCnpj(codigo);

                if (dataCar.existemDados || listaSigef.length) {
                    this.mostrarModalDadosCpfCnpj = true;
                    this.carVinculadoCpfCnpj = codigo;
                    this.dados = {
                        listaSigef,
                        ...dataCar
                    };
                } else {
                    this.$notify.info({
                        message: this.$t(
                            'mensagens.territorio.naoForamEncontradosDadosCpfCnpj'
                        )
                    });
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroNaRequisicaoTenteNovamente'
                    )
                });
            }
        },

        async buscarParcelaPorINCRA() {
            try {
                const { data: listaSigef } = await SigefService.consultarINCRA(
                    this.carCodigo
                );

                if (listaSigef.length) {
                    this.mostrarModalDadosCpfCnpj = true;
                    this.carVinculadoCpfCnpj = this.carCodigo;
                    this.dados = {
                        listaSigef
                    };
                } else {
                    this.$notify.info({
                        message: this.$t(
                            'mensagens.territorio.naoForamEncontradosDadosNumeroIncra'
                        )
                    });
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroNaRequisicaoTenteNovamente'
                    )
                });
            }
        },

        findCarByCode() {
            let codigo = this.carCodigo.replace(/[^\w\s]/gi, '');
            territorioService
                .findByCar(this.carCodigo)
                .then(response => {
                    if (response.status === 200) {
                        let type = 'CAR';
                        let responseData = response.data.camadas.find(el => {
                            if (el.camada.codigo === 'IMOVEL_RURAL') {
                                return el.resultados[0];
                            }
                        }).resultados[0];

                        let resultado = {
                            ...responseData,
                            ...responseData.properties,
                            type,
                            identificadorGeometria: codigo
                        };
                        this.carSelected = {
                            codigo: resultado.codigo,
                            condicao: resultado.condicao
                        };

                        this.gemotryByCarCode = resultado.geometry;

                        delete resultado.properties;

                        this.mostrarTerritorioNoMapa(
                            responseData.geometry,
                            codigo
                        );

                        if (!this.dadoJaFoiAdicionado(resultado.codigo)) {
                            if (!resultado.codigo) {
                                resultado.codigo = formatters.formatCar(
                                    resultado.identificadorGeometria
                                );
                            }
                            this.setTerritoryTableData(resultado);
                        } else {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.territorio.carJaSelecionado'
                                )
                            });
                        }
                        this.carCodigo = null;
                    } else if (response.status === 204) {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.carNaoEncontrado'
                            )
                        });
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.erroConsultarCarInserido'
                            )
                        });
                    }
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.erroConsultarCarInserido'
                        )
                    })
                );
        },
        findCar() {
            if (this.carCodigo) {
                this.carsCpfCnpj = [];
                let codigo = this.carCodigo.replace(/[^\w\s]/gi, '').length;

                if (codigo === 11 || codigo === 14) {
                    this.buscarCarPorCpfCnpjVinculado();
                } else if (this.carCodigo.length === 36) {
                    this.buscarSigefPorCodigoParcela();
                } else if (this.carCodigo.length === 13) {
                    this.buscarParcelaPorINCRA();
                } else {
                    this.findCarByCode();
                }
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.informeCodigoCarOuCpfCnpjValido'
                    )
                });
            }
        },
        adicionarDadosSelecionadosNaModalNoMapa(dadosSelecionados) {
            this.mostrarModalDadosCpfCnpj = false;
            this.layersMaps = [];

            Object.keys(dadosSelecionados).forEach(conjunto => {
                if (conjunto === 'sigef') {
                    dadosSelecionados[conjunto].forEach(
                        async ({ codigoParcela }) => {
                            const { data } =
                                await SigefService.buscarGeometriaParcela(
                                    codigoParcela
                                );

                            const geometriaParcela = JSON.parse(data);

                            const resultado = {
                                codigo: codigoParcela,
                                identificadorGeometria: codigoParcela,
                                type: 'Parcela Incra',
                                geometry: geometriaParcela,
                                area_ha:
                                    geometryUtils.calcularAreaHaFromGeoJSON(
                                        geometriaParcela
                                    )
                            };

                            this.mostrarTerritorioNoMapa(
                                geometriaParcela,
                                resultado.identificadorGeometria
                            );

                            if (!this.dadoJaFoiAdicionado(codigoParcela)) {
                                this.setTerritoryTableData(resultado);
                            }
                        }
                    );
                } else {
                    dadosSelecionados[conjunto].forEach(async ({ codigo }) => {
                        const { data } = await CarService.buscarGeometria(
                            codigo
                        );

                        const resultado = {
                            codigo,
                            identificadorGeometria: codigo,
                            type: 'CAR',
                            geometry: data
                        };

                        this.mostrarTerritorioNoMapa(
                            data,
                            resultado.identificadorGeometria
                        );

                        if (!this.dadoJaFoiAdicionado(codigo)) {
                            this.setTerritoryTableData(resultado);
                        }
                    });
                }
            });

            this.carCodigo = null;
        },
        handleChangeSelectInput() {
            this.$nextTick(() => {
                this.$refs.elselectinput.query = '';
            });
        },
        checkIfIsValid() {
            if (
                this.$v.territorio.$invalid ||
                this.territoryTableData.length !== 1
            ) {
                if (
                    this.$v.territorio.$invalid ||
                    (this.permissaoAmbiente(this.ambientes.PARAGUAY) &&
                        this.$v.camposParaguay.$invalid)
                ) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.verifiqueCamposObrigatorios'
                        )
                    });
                    return false;
                }

                if (this.$v.territorio.$invalid) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.verifiqueCamposObrigatorios'
                        )
                    });
                    return false;
                }
                if (this.territoryTableData.length !== 1) {
                    // Need this so we don't overlap notifications
                    setTimeout(() => {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.verifiqueTerritoriosConsolidados'
                            )
                        });
                    }, 200);
                    return false;
                }
            }
            if (this.territorioSobrePostoMessage) {
                this.territorioSobrePosto = true;
                return false;
            }

            return true;
        },
        adicionarDesenho(desenho) {
            let territoryPropertyConverionToTableData = {};
            territoryPropertyConverionToTableData.identificadorGeometria =
                desenho._leaflet_id;
            desenho.identificadorGeometria = desenho._leaflet_id;

            territoryPropertyConverionToTableData.type = 'Desenho de geometria';
            territoryPropertyConverionToTableData.codigo = 'DESENHO';
            territoryPropertyConverionToTableData.area_ha =
                geometryUtils.calcularAreaHaFromLayer(desenho);
            territoryPropertyConverionToTableData.geometry =
                desenho.toGeoJSON().geometry;

            this.geometryDesenho = desenho.toGeoJSON().geometry;
            this.setTerritoryTableData(territoryPropertyConverionToTableData);
            this.clearSobreposicaoTerritorio();
        },
        desenhosAlterados(desenhosAlterados) {
            desenhosAlterados.eachLayer(layer => {
                const areaHa = geometryUtils.calcularAreaHaFromLayer(layer);
                const geometry = layer.toGeoJSON().geometry;
                this.territoryTableData.findIndex(
                    t => t.identificadorGeometria === layer._leaflet_id
                );
                this.replaceTerritoryTableData({
                    identificadorGeometria: layer._leaflet_id,
                    geometry,
                    areaHa
                });
            });
        },

        savarCarsVinculados(carsVinculados) {
            this.territorio['carsVinculados'] = [...carsVinculados];
            this.dialogListaCarSelect = false;
            this.salvarTerritorio();
        },

        validarComercializacao() {
            let valido = true;
            if (this.territorio.comercializacoes) {
                for (
                    var i = 0;
                    i < this.territorio.comercializacoes.length;
                    i = i + 1
                ) {
                    if (
                        !this.territorio.comercializacoes[i].produto.id ||
                        this.territorio.comercializacoes[i].quantidade === 0 ||
                        !this.territorio.comercializacoes[i].unidadeMedida.id
                    ) {
                        valido = false;
                    }
                    if (
                        !this.territorio.comercializacoes[i].produto.id &&
                        this.territorio.comercializacoes[i].quantidade === 0 &&
                        !this.territorio.comercializacoes[i].unidadeMedida.id &&
                        i === 0
                    ) {
                        valido = true;
                    }
                }
            }
            return valido;
        },

        async buscarSigefPorCodigoParcela() {
            const { data } = await SigefService.buscarGeometriaParcela(
                this.carCodigo
            );

            const geometriaParcela = JSON.parse(data);

            if (data === '') {
                this.$notify.warning(
                    this.$t(
                        'mensagens.territorio.erroParcelaInseridaNaoEncontrada'
                    )
                );
                return;
            }

            const resultado = {
                codigo: this.carCodigo,
                identificadorGeometria: this.carCodigo,
                type: 'Parcela Incra',
                geometry: geometriaParcela,
                area_ha:
                    geometryUtils.calcularAreaHaFromGeoJSON(geometriaParcela)
            };

            this.mostrarTerritorioNoMapa(
                geometriaParcela,
                resultado.identificadorGeometria
            );

            if (!this.dadoJaFoiAdicionado(this.carCodigo)) {
                this.setTerritoryTableData(resultado);
            }
        },

        addPropSafraComercializacoes() {
            if (this.territorio.comercializacoes) {
                this.territorio.comercializacoes.forEach(comercializacao => {
                    if (!comercializacao.safra) {
                        comercializacao.safra = {};
                    }
                });
            }
        },

        removePropSafraComercializacoes() {
            if (
                this.territorio.comercializacoes &&
                this.territorio.comercializacoes.length > 0
            ) {
                this.territorio.comercializacoes.forEach(comercializacao => {
                    if (Object.keys(comercializacao.safra).length === 0) {
                        delete comercializacao.safra;
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss">
.cadastro-territorio {
    display: flex;
    flex-direction: column;

    button {
        width: fit-content;
        cursor: pointer;
    }

    .required-text {
        color: var(--danger);
    }

    .m-25 {
        margin-top: 25px;
    }
}

.posicao-botao {
    display: flex;
    justify-content: space-between;
}

.formContainer {
    background-color: var(--white);
    border-radius: 5px;
    padding: 20px;

    .titulo {
        padding-bottom: 8px;
    }
}

.el-upload {
    flex: 1;

    .el-icon-upload {
        font-size: 40px;
        margin: 0px;
    }
}

.el-collapse-item {
    border-bottom: 1px solid #ebeef5;
}

.el-upload-dragger {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center !important;
    justify-content: center !important;
    flex-direction: column !important;
}

.el-form-item__label {
    margin-bottom: 0px;
}

.left .el-tooltip__popper,
.right .el-tooltip__popper {
    padding: 8px 10px;
}

.form-alignment {
    height: 108px;
}

.el-form-item.form-size.separator.my-3.is-required {
    height: 80px;
}

el-form.formContainer.w-100.mb-3.form-alignment.el-form-item__content {
    line-height: 20px;
}

.error {
    line-height: 20px;
}

.voltar {
    cursor: pointer;
    line-height: 2;
}

.mapa {
    border-radius: 4px;
    overflow: hidden;
}

.btn-selecao-mapa-body {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
        margin-right: 5px;
    }
}

.pre-formatted {
    white-space: pre-line;
}

.form-size {
    width: 100%;
}

.form-alignment {
    display: flex;
    align-items: center;
}

.cadastro-territorio-campos {
    display: flex;
    gap: 20px;

    .el-form-item__content {
        width: 100%;
        margin-bottom: 0px !important;
    }

    .el-form-item-campos {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .el-select {
            width: 100%;
        }
    }
}

.separator {
    margin-right: 20px;
}

.el-dialog__header {
    background: #f6f6f6 !important;
    padding-bottom: 20px !important;
}

.el-dialog__title,
.el-icon {
    color: #183b57 !important;
}

.el-dialog__body {
    color: #3b3b3b !important;
    font-size: normal !important;
    flex-direction: column;
    display: flex;
}

.territorio {
    padding: 15px 0;
    flex-direction: column;
    display: flex;
}

footer {
    display: flex;
    justify-content: space-between;
}

.invalido {
    color: var(--danger);
}

.espaco {
    display: flex;
}

.el-form-item .el-form-item__label {
    font-weight: normal !important;
}
</style>
